export const months =[
    "jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"
]

export const years = [2024,2025,2026,2027,2028,2029,2030];